import { EcsActionType } from "../actions";
export function localEditStateReducer(state = {}, action) {
    var _a;
    switch (action.type) {
        case EcsActionType.UpdateAttributeValue: {
            if (!action.payload.isEditable) {
                return state;
            }
            const { attributePath, value } = action.payload;
            return Object.assign(Object.assign({}, state), { [attributePath]: value });
        }
        case EcsActionType.ReplaceConfiguration:
            /// when no connections are open any more, the state may be reset
            /// syncState === 1 due to the connection counter being decremented
            /// after replace-configuration
            return ((_a = action.meta) === null || _a === void 0 ? void 0 : _a.syncState) === 1 ? {} : state;
        case EcsActionType.ResetAll:
            return {};
        default:
            return state;
    }
}
//# sourceMappingURL=localEditStateReducer.js.map